<template>
  <div class="sjbz">
    <div class="banners">
      <div class="banner-title">
        <div class="t1">数据标注服务</div>
        <div class="t2">为企业AI研发与落地提供高质量测试和标注数据</div>
      </div>
      <video
        src="../assets/img/banner1.mp4"
        autoplay
        loop
        muted
        style="width: 100%; height: 100%; object-fit: cover; position: absolute; top: 0; left: 0;"
      />
    </div>
    <div class="content-cr">
      <div
        style="display: flex; justify-content: space-between;margin-top: 60px;"
      >
        <img
          style="margin-bottom: -200px;width: 400px;height: 600px;object-fit: contain;"
          src="../assets/img/zq/tp2.png"
          alt=""
        />
        <div style="margin-left: 40px;">
          <div
            style="font-size: 32px;margin-bottom: 50px;list-style: 60px;color:#333"
          >
            数据标注服务
          </div>
          <div style="font-size: 24px;line-height: 48px;color:#666">
            中启联信致力于为企业AI研发与落地提供高质量测试和标注数据，助力企业机器学习项目的快速部署，全面提升模型性能;拥有先进的数据标注平台与成熟的标注、审核、质检机制,资源及合作伙伴遍布全球数十个国家,和企业一起构建
            AI数据核心竞争力。
          </div>
        </div>
      </div>
    </div>
    <div class="content-1">
      <div class="content-1-1">
        <div class="title-top">
          <img src="../assets/img/left.png" alt="" />
          <div class="title1">数据标注服务能力</div>
          <img src="../assets/img/right.png" alt="" />
        </div>
        <!-- 视频标注 -->
        <div class="bz-1">
          <div class="bz-list">
            <div class="img-1">
              <img src="../assets/img/zq/caiji-type-1-4.png" alt="" />
            </div>
            <div class="list-r">
              <div class="list-r-1">
                <div>视频标注</div>
              </div>
              <div class="list-r-2">
                <div class="list-r-2-1">语义分割</div>
                <div class="list-r-2-1">实例分割</div>
                <div class="list-r-2-1">目标检测</div>
                <div class="list-r-2-1">3D影像/序列图像</div>
                <div class="list-r-2-1">关键点标注</div>
                <div class="list-r-2-1">图像分类计数</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 文本标注 -->
        <div class="bz-1">
          <div class="bz-list">
            <div class="list-r">
              <div class="list-r-1">
                <div>文本标注</div>
              </div>
              <div class="list-r-2">
                <div class="list-r-2-1">文本清洗</div>
                <div class="list-r-2-1">文本分类</div>
                <div class="list-r-2-1">情绪标注</div>
                <div class="list-r-2-1">意图识别标注</div>
                <div class="list-r-2-1">词性标注</div>
                <div class="list-r-2-1">对话语料库构建</div>
              </div>
            </div>
            <div class="img-1">
              <img
                style="width: 100%;"
                src="../assets/img/zq/caiji-type-1-5.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- 点云标注 -->
        <div class="bz-1">
          <div class="bz-list">
            <div class="img-1">
              <img
                style="width: 100%;"
                src="../assets/img/zq/caiji-type-1-2.png"
                alt=""
              />
            </div>
            <div class="list-r">
              <div class="list-r-1">
                <div>点云标注</div>
              </div>
              <div class="list-r-2">
                <div class="list-r-2-1">点云图像标注</div>
                <div class="list-r-2-1">点云目标标注</div>
                <div class="list-r-2-1">点云目标追踪</div>
                <div class="list-r-2-1">点云关键点</div>
                <div class="list-r-2-1">点云分割</div>
                <div class="list-r-2-1">点云2 3D融合标注</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 大模型标注 -->
        <div class="bz-1">
          <div class="bz-list">
            <div class="list-r">
              <div class="list-r-1">
                <div>大模型标注</div>
              </div>
              <div class="list-r-2">
                <div class="list-r-2-1">指令标注</div>
                <div class="list-r-2-1">指令CoT描述</div>
                <div class="list-r-2-1">答案修正</div>
                <div class="list-r-2-1">人机对话</div>
                <div class="list-r-2-1">多模态标注</div>
                <div class="list-r-2-1">特定领域知识标注</div>
              </div>
            </div>
            <div class="img-1">
              <img
                style="width: 100%;"
                src="../assets/img/zq/caiji-type-1-1.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- 优势 -->
        <div class="content-1">
          <div class="content-1-1">
            <div class="title-top">
              <img src="../assets/img/left.png" alt="" />
              <div class="title1">数据标注优势</div>
              <img src="../assets/img/right.png" alt="" />
            </div>
          </div>
          <div class="bz-2">
            <div class="bz-2-card" v-for="(item, index) in ysLIst" :key="index">
              <div style="margin-top:20px;">
                <img style="width: 80px;" :src="item.img" alt="" />
              </div>
              <div class="bz-2-card-1">{{ item.title }}</div>
              <div class="bz-2-card-2">{{ item.content }}</div>
            </div>
          </div>
        </div>
        <!-- 流程 -->
        <div class="content-1">
          <div class="content-1-1">
            <div class="title-top">
              <img src="../assets/img/left.png" alt="" />
              <div class="title1">标注服务流程</div>
              <img src="../assets/img/right.png" alt="" />
            </div>
          </div>
          <div class="bz-3">
            <div>
              <img
                style="width: 128px;"
                src="../assets/img/zq/lc1.png"
                alt=""
              />
              <div class="bz-3-1">需求评估</div>
            </div>
            <div>
              <img
                style="width: 80px;"
                src="../assets/img/zq/right.png"
                alt=""
              />
            </div>
            <div>
              <img
                style="width: 128px;"
                src="../assets/img/zq/lc2.png"
                alt=""
              />
              <div class="bz-3-1">标注方案确认</div>
            </div>
            <div>
              <img
                style="width: 80px;"
                src="../assets/img/zq/right.png"
                alt=""
              />
            </div>
            <div>
              <img
                style="width: 128px;"
                src="../assets/img/zq/lc3.png"
                alt=""
              />
              <div class="bz-3-1">试标注</div>
            </div>
            <div>
              <img
                style="width: 80px;"
                src="../assets/img/zq/right.png"
                alt=""
              />
            </div>
            <div>
              <img
                style="width: 128px;"
                src="../assets/img/zq/lc4.png"
                alt=""
              />
              <div class="bz-3-1">质量确认</div>
            </div>
            <div>
              <img
                style="width: 80px;"
                src="../assets/img/zq/right.png"
                alt=""
              />
            </div>
            <div>
              <img
                style="width: 128px;"
                src="../assets/img/zq/lc5.png"
                alt=""
              />
              <div class="bz-3-1">批量标注</div>
            </div>
          </div>
        </div>
        <!-- 应用场景 -->
        <div class="content-1">
          <div class="content-1-1">
            <div class="title-top">
              <img src="../assets/img/left.png" alt="" />
              <div class="title1">应用场景</div>
              <img src="../assets/img/right.png" alt="" />
            </div>
          </div>
          <div class="bz-4">
            <div
              class="bz-4-card"
              @mouseenter="hovercjIndex = index"
              @mouseleave="hovercjIndex = null"
              v-for="(item, index) in cjList"
              :key="index"
              :style="
                `background-image: url(${require('../assets/img/zq/scene' +
                  (index + 1) +
                  '.png')})`
              "
            >
              <div class="card-title" v-if="hovercjIndex != index">
                {{ item.title }}
              </div>
              <div class="card-content" v-if="hovercjIndex == index">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Banner from "../components/Banner";
export default {
  metaInfo: {
    title: "中启联信_数据标注",
    meta: [
      { name: "keywords", content: "中启联信、数据标注" },
      { name: "description", content: "中启联信、数据标注" },
    ],
  },
  data() {
    return {
      hovercjIndex: null,
      hoverIndex: 0,
      tabPosition: "left",
      activeName: "first",
      cjList: [
        {
          title: "内容审核场景",
          content:
            "通过专业的标注实现对问答评论、昵称签名、日记帖子、 恶意推广、图文图集、音视频弹幕中的内容合规合法性进行识别。",
        },
        {
          title: "智能安防",
          content:
            "核心能力包括人脸打点、骨骼关键点、人体拉框、视频切分、目标跟踪、语义分割等标注类型，支持平安城市、车辆人流监测人脸识别等场景数据标注。",
        },
        {
          title: "智能金融",
          content:
            "核心能力包括车辆保险鉴定、人物对话转写、命名实体识别、票据文字识别(OCR)、人脸标注、风控数据标注等标注类型，支持身份认证、智能风控、智慧柜台等场景数据标注。",
        },
        {
          title: "智能驾驶",
          content:
            "核心能力包括图片通用拉框、车道线、DMS、3D点云、2D/3D融合、全景语义分割等标注类型，支持自动驾驶、智能驾舱、自动泊车等场景数据标注。",
        },
        {
          title: "智能家居",
          content:
            "核心能力包括人物语音转写、行为意图、声纹识别、领域识别、语句泛化、语义分割等标注类型，支持智能音箱、智能电视、智能扫地机器人等场景数据标注。",
        },
        {
          title: "新零售",
          content:
            "核心能力包括商品分类识别、票据识别转写、服饰拉框、商品属性、人脸表情、目标跟踪等标注类型，支持智慧门店、无人货柜、虚拟试衣等场景数据标注。",
        },
      ],
      ysLIst: [
        {
          img: require("../assets/img/zq/caiji-youshi-1-0.png"),
          title: "数据安全专业的团队",
          content:
            "在全国自建多个数据中心，有众多稳定的外包合作供应商，包括众包资源。专属项目经理全程多维度管控，确保数据交付质量。",
        },
        {
          img: require("../assets/img/zq/caiji-youshi-1-1.png"),
          title: "数据标注的全面覆盖",
          content:
            "包括大模型、图像视频、3D标注、4D标注、多语言文本语音标注，以及内容相关性标注。涵盖多种标注工具套组、项目管理、工作流、AI辅助标注等，支持快速高效的数据标注交付。",
        },
        {
          img: require("../assets/img/zq/caiji-youshi-1-2.png"),
          title: "定制化数据采集流程",
          content:
            "拥有庞大的众包团队和各领域合作伙伴，支持全球数据采集需求，针对细分AI应用场景进行数据定制。数据采集支持大规模数据采集及数据清理、质量检测、预识别等，保证项目交付的质量和效率。",
        },
        {
          img: require("../assets/img/zq/caiji-youshi-1-3.png"),
          title: "成品数据集的多样性和实用性",
          content:
            "提供200+成品数据集，包括ASR、文本、发音词典、图像及视频，为快速部署提供高质量数据支持。",
        },
      ],
      sjList: [
        {
          title: "数据治理",
          content:
            "确定数据标准;\n数据清洗;\n数据管理能力评估;\n数据资源目录梳理;\n……",
        },
        {
          title: "数据确权",
          content:
            "了解数据登记情况;\n界定数据来源、持有加工、流通、使用过程中的合法权利;\n明确权利或权利组合;\n获取相关权证材料;\n……",
        },
        {
          title: "数据入表专业咨询",
          content:
            "数据资产确认条件;\n基于场景的预期收益合理性判断;\n资产分类的合理性和确定依据分析;\n后续计量的价值影响分析;\n……",
        },
        {
          title: "数据资产质量评价",
          content:
            "明确数据质量评价对象及范围;\n建立质量要素评价指标体系;\n执行数据质量评价程序;\n撰写数据质量评价报告;\n……",
        },
        {
          title: "数据资产价值评估",
          content:
            "明确评估对象和范围明确应用场景和资产类型;\n数据资产评估方法适用性分析;\n数据资产价值评估;\n出具价值评估报告;\n……",
        },
      ],
      itemList: [
        {
          bg: require(`@/assets/img/advantage-0.png`),
          title: "上千次项目打磨",
        },
        {
          bg: require(`@/assets/img/advantage-1.png`),
          title: "100%项目交付质量",
        },
        {
          bg: require(`@/assets/img/advantage-2.png`),
          title: "量身打造定制化方案",
        },
        { bg: require(`@/assets/img/advantage-3.png`), title: "50+技术软著" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.sjbz {
  width: 100%;
  .content-3 {
    margin-top: 80px;
    .content-3-1 {
      text-align: center;
    }
    .content-3-2 {
      width: 1400px;
      margin: 68px auto;
      display: flex;
      justify-content: space-between;
      .box1 {
        width: 288px;
        height: 274px;
        background: #3a4354;
        border-radius: 6px;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
        .box1-1 {
          display: block;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 45px;
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          color: #fff;
          line-height: 24px;
        }
        .box1-2 {
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          overflow: hidden;
          color: #fff;
          text-align: center;
          opacity: 0;
          -webkit-animation: advantageHide 1s;
          animation: advantageHide 1s;
          @keyframes advantageHide {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .content-2 {
    background: #f9fbff;
    width: 100%;
    padding-top: 60px;
    min-width: 1200px;
    .content-2-3 {
      // width: 1200px;
      margin: 20px auto;
      ::v-deep .el-tabs__nav-scroll {
        width: 10%;
        margin: 0 auto;
      }
      .content-2-3-1 {
        width: 100%;
        min-width: 1200px;
        height: 23.43vw;
        background: #2b3953;
        position: relative;
        margin-top: 4.9vw;
        .text1 {
          text-align: left;
          color: #fff;
          width: 62.5vw;
          margin: 0 auto;
          padding-top: 5.28vw;
        }
        .img1 {
          opacity: 1;
          width: 50vw;
          height: 26.84vw;
          position: absolute;
          right: 0;
          bottom: 0;
          transition: all 0.5s ease-in 0.5s;
          animation: fadeIn 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
        .img2 {
          width: 30.15vw;
          height: 15.98vw;
          position: absolute;
          right: 30.57vw;
          bottom: 0;
          animation: slide-in-bottom 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
            forwards;
          @keyframes slide-in-bottom {
            0% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
    .content-2-1 {
      text-align: center;
    }
    .content-2-2 {
      margin: 32px auto;
      text-align: center;
      .tabs {
        margin: 0 auto;

        ::v-deep .el-radio-button__inner {
          width: 400px;
          height: 48px;
          line-height: 24px;
          font-size: 20px;
        }
      }
    }
  }
  .content-1 {
    background: #fff;
    width: 100%;
    min-width: 1400px;
    .content-1-1 {
      text-align: center;
      .title-top {
        display: flex;
        justify-content: center;
        align-items: center;
        .title1 {
          font-size: 36px;
          margin: 0px 20px;
        }
      }
      // &:active {
      //   background: linear-gradient(135deg, #526aff, #7caefb) !important;
      //   color: #fff;
      // }
    }
  }
  .content-cr {
    width: 1400px;
    margin: 0 auto;
  }
  .bz-4 {
    margin: 40px auto;
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .bz-4-card {
      width: 432px;
      height: 210px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      margin-bottom: 20px;
      position: relative;
      .card-title {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 24px;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
      }
      .card-content {
        width: calc(100% - 80px);
        height: calc(100% - 80px);
        line-height: 30px;
        text-align: center;
        font-size: 20px;
        color: #fff;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        bottom: 0;
        padding: 40px;
      }
    }
  }
  .bz-3 {
    margin: 40px auto;
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .bz-3-1 {
      font-size: 32px;
      font-weight: bold;
      color: #7caefb;
    }
  }
  .bz-2 {
    width: 1400px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 38px;
    margin: 40px auto;
    .bz-2-card {
      .bz-2-card-1 {
        font-size: 24px;
        font-weight: bold;
        color: rgb(24, 24, 24);
        line-height: 25px;
        margin: 30px auto 16px;
      }
      .bz-2-card-2 {
        text-align: left;
        text-indent: 2em;
        font-size: 18px;
        font-weight: 400;
        color: rgb(112, 117, 127);
        line-height: 30px;
        width: 540px;
        margin: auto;
      }
      width: calc(50% - 40px);
      height: 330px;
      text-align: center;
      margin-bottom: 18px;
      margin-left: 11px;
      margin-right: 11px;
      background: transparent;
      border-radius: 4px;
      border-width: 1px;
      border-style: solid;
      border-color: rgb(220, 226, 239);
      border-image: initial;
      &:hover {
        box-shadow: rgba(0, 0, 0, 0.06) 4px 6px 20px 0px;
        background: rgb(255, 255, 255);
        border-width: 1px;
        border-style: solid;
        border-color: rgb(220, 226, 239);
        border-image: initial;
      }
    }
  }
  .bz-1 {
    margin: 40px 0;
    width: 100%;
    min-width: 1400px;
    .bz-list {
      width: 1400px;
      display: flex;
      justify-content: space-between;
      margin: 0px auto;
      .img-1 {
        width: 516px;
        height: 326px;
      }
      .list-r {
        width: 592px;
        height: 345px;
        position: relative;
        .list-r-2 {
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          .list-r-2-1 {
            width: 295px;
            margin-top: 10px;
            color: rgb(58, 67, 84);
            font-size: 24px;
            line-height: 60px;
            position: relative;
            text-align: left;
            &::before {
              content: "";
              display: inline-block;
              width: 5px;
              height: 5px;
              position: relative;
              top: -3px;
              margin-right: 10px;
              background: rgb(82, 106, 255);
              border-radius: 50%;
            }
          }
        }
        .list-r-1 {
          color: rgb(58, 67, 84);
          font-size: 28px;
          font-weight: 700;
          position: relative;
          display: flex;
          justify-content: space-between;
          z-index: 3 !important;
          &::before {
            content: "";
            position: absolute;
            left: -2px;
            top: 1px;
            display: block;
            width: 60px;
            height: 36px;
            z-index: -1 !important;
            background: linear-gradient(
              315deg,
              rgba(124, 174, 251, 0),
              rgb(82, 106, 255)
            );
            border-radius: 4px;
          }
        }
        &::before {
          content: "";
          display: block;
          position: absolute;
          right: 0px;
          bottom: 0px;
          width: 42px;
          height: 12px;
          z-index: 1;
          background: linear-gradient(
            95deg,
            rgba(124, 174, 251, 0),
            rgb(82, 106, 255)
          );
          border-radius: 4px;
        }
      }
    }
  }
  .content-1-2 {
    display: flex;
    margin-top: 30px;
    .home-app-left {
      width: 250px;
      height: 467px;
      background: linear-gradient(296deg, #7caefb, #526aff);
      box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
      border-radius: 6px 0 0 6px;
      .t1 {
        font-size: 20px;
        color: #fff;
        line-height: 60px;
        margin: 20px 0;
      }
    }
    .home-app-center {
      width: 900px;
      height: 247px;
      background-image: url(https://databaker-gw-static.oss-accelerate.aliyuncs.com/assets/images/newHome/app-bg.png);
      background-size: 100% 100%;
      box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
      border-radius: 0 6px 6px 0;
      position: relative;
      text-align: center;
      font-size: 40px;
      padding-top: 220px;
    }
    .home-app-right {
      width: 250px;
      height: 467px;
      background: linear-gradient(296deg, #7caefb, #526aff);
      box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
      border-radius: 6px 0 0 6px;
    }
  }
}
.home-achieve {
  position: relative;
  width: 1400px;
  margin: -60px auto;
  display: flex;
  z-index: 3;
  justify-content: space-between;
  .cards {
    transform: translateY(0px);
    opacity: 1;
    animation-delay: 200ms;
    width: 388px;
    height: 112px;
    background: #fff;
    box-shadow: 2px 6px 10px 0 rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    display: flex;
  }
}
.banners {
  width: 100%;
  height: 400px;
  position: relative;
  .banner-title {
    position: absolute;
    z-index: 3;
    width: 1400px;
    min-width: 1400px;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    .t1 {
      font-size: 2.2vw;
      font-family: Alibaba-PuHuiTi-Bold;
      color: #3a4354;
      font-weight: bold;
    }
    .t2 {
      font-size: 1.2vw;
      width: 567px;
      font-weight: 400;
      color: #3a4354;
      line-height: 40px;
      margin-top: 23px;
      font-family: Alibaba-PuHuiTi-Regular;
    }
  }
  video {
    height: 100%;
    width: 100%;
    position: absolute;
    right: 0px;
    top: 0px;
    // bottom: 0px;
    z-index: -1;
  }
}
</style>
